import PropTypes from 'prop-types';
import styled from 'styled-components';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGClose from 'visitor-ui-component-library-icons/icons/SVGClose';
import { createTheme } from 'visitor-ui-component-library/theme/createTheme';
import { setTransparentOnBackgroundIconButton } from 'visitor-ui-component-library/button/theme/iconButtonThemeOperators';
import { MARIGOLD_LIGHT, MARIGOLD_MEDIUM, OBSIDIAN } from 'visitor-ui-component-library/constants/WidgetColors';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "ChatAreaAlert__Wrapper"
})(["width:100%;display:flex;justify-content:center;background-color:transparent;"]);
const Alert = styled.div.withConfig({
  displayName: "ChatAreaAlert__Alert"
})(["display:flex;justify-content:flex-end;align-items:center;padding:7px 14px;min-width:85%;background-color:", ";border:1px solid ", ";font-weight:500;font-size:12px;"], MARIGOLD_LIGHT, MARIGOLD_MEDIUM);
const Title = styled.div.withConfig({
  displayName: "ChatAreaAlert__Title"
})(["flex:0 1 100%;"]);
const LinkWrapper = styled.div.withConfig({
  displayName: "ChatAreaAlert__LinkWrapper"
})(["flex:0 0 auto;"]);
const StyledCloseButton = styled(VizExIconButton).withConfig({
  displayName: "ChatAreaAlert__StyledCloseButton"
})(["position:static;flex:0 0 36px;margin-left:8px;margin-right:-8px;"]);
const ChatAreaAlert = ({
  title,
  link,
  onClose
}) => {
  return /*#__PURE__*/_jsx(Wrapper, {
    "data-test-id": "alert",
    role: "alert",
    children: /*#__PURE__*/_jsxs(Alert, {
      children: [/*#__PURE__*/_jsx(Title, {
        children: title
      }), link && /*#__PURE__*/_jsx(LinkWrapper, {
        children: link
      }), /*#__PURE__*/_jsx(StyledCloseButton, {
        use: "transparent-on-background",
        theme: setTransparentOnBackgroundIconButton(OBSIDIAN, createTheme()),
        "aria-label": I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.dismiss'),
        onClick: onClose,
        children: /*#__PURE__*/_jsx(VizExIcon, {
          icon: /*#__PURE__*/_jsx(SVGClose, {})
        })
      })]
    })
  });
};
ChatAreaAlert.propTypes = {
  link: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired
};
ChatAreaAlert.displayName = 'ChatAreaAlert';
export default ChatAreaAlert;